/* eslint-disable */
import config from '@/config';
import ContentPDFGeneratorInc from './ContentPDFGenerator'
import htmlToPdfmake from 'html-to-pdfmake'

export const generatePDF = (creatorConceptData) => {
  let document = ContentPDFGeneratorInc.contentConfig();
  let content = document.content
  content.push({
    text: 'Content Storyboard Flow',
    style: 'header'
  },
  {
    text: `Campaign Name: ${creatorConceptData.campaignName}`,
    style: 'subheader'
  },
  {
    text: `Creator Handle: ${creatorConceptData.creatorHandle}`,
    style: 'subheader'
  },
  {
    text: `Draft Submission Date: ${creatorConceptData.submissionDate}`,
    style: 'subheader'
  },
  {
    text: `Deliverable Details: ${creatorConceptData.deliverableLists}`,
    style: 'subheader'
  })
  for (let deliItem of creatorConceptData.deliverables) {
    content.push({
      text: deliItem.title,
      style: 'middleHeader'
    })
    if (deliItem.type !== 'igCarousel' && deliItem.type !== 'linkedIn') {
      if (deliItem.type === 'igReel') {
        content.push( {
          text: `Concept: ${deliItem.concept}`,
          style: 'subheader'
        })
        content.push( {
          text: `Reason for concept: ${deliItem.reasonConcept}`,
          style: 'subheader'
        })
        content.push( {
          text: `Music choice: ${deliItem.musicChoice}`,
          style: 'subheader'
        })
      }
      for (let boxItem of deliItem.boxes) {
        let imageLinks = []
        for (let imgItem of boxItem.images) {
          if (imgItem.refLinkType === 'link') {
            imageLinks.push(imgItem.link)
          } else {
            imageLinks.push(imgItem.imgUrl)
          }
        }
        content.push({
          table: {
            widths: [160, 160, 160],
            body: [
              [
                { text: 'Descriptions of scenes/ footage', style: 'tableHeader' },
                { text: 'Include text overlays / voiceover script in each scene', style: 'tableHeader' },
                { text: 'Reference links/images', style: 'tableHeader' }
              ],
              [
                {
                  text: ContentPDFGeneratorInc.formatTextBlocks(boxItem.scenesInfo),
                  margin: [0, 5],
                  fontSize: 12,
                  style: 'tableTxt',
                },
                {
                  text: ContentPDFGeneratorInc.formatTextBlocks(boxItem.briefText),
                  margin: [0, 5]
                },
                { text: imageLinks.join(','), margin: [0, 5] }
              ],
              // Add more rows as needed
              [
                {
                  text: ContentPDFGeneratorInc.formatTextBlocks(boxItem.bodyInfo),
                  margin: [0, 5]
                },
                {
                  text: ContentPDFGeneratorInc.formatTextBlocks(boxItem.briefPointer),
                  margin: [0, 5]
                },
                {
                  text: '',
                  margin: [0, 5]
                }
              ],
              [
                {
                  text: ContentPDFGeneratorInc.formatTextBlocks(boxItem.callToAction),
                  margin: [0, 5],
                  colSpan: 3
                },
                {
                  text: '',
                  margin: [0, 5]
                },
                {
                  text: '',
                  margin: [0, 5]
                }
              ],
            ]
          }
        })
      }
    }
    if (deliItem.type === 'igCarousel' || deliItem.type === 'linkedIn') {
      for (let boxItem of deliItem.boxes) {
        let imageLinks = []
        for (let imgItem of boxItem.images) {
          if (imgItem.refLinkType === 'link') {
            imageLinks.push(imgItem.link)
          } else {
            imageLinks.push(imgItem.imgUrl)
          }
        }
        let carouselItems = [
          [
            { text: 'IMAGE', style: 'tableHeader' },
            { text: 'Description of image/gif', style: 'tableHeader' },
            { text: 'Text on image (if any)', style: 'tableHeader' },
            { text: 'Reference image', style: 'tableHeader' }
          ]
        ]
        for (const [imgRowIndex, imgRow] of Object.entries(boxItem.images)) {
          carouselItems.push([
            {
              text: imgRowIndex + 1,
              margin: [0, 5]
            },
            {
              text: imgRow.imgDescription ? ContentPDFGeneratorInc.formatTextBlocks(imgRow.imgDescription) : '',
              margin: [0, 5]
            },
            {
              text: imgRow.textImage ? ContentPDFGeneratorInc.formatTextBlocks(imgRow.textImage) : '',
              margin: [0, 5]
            },
            { text: imageLinks.join(','), margin: [0, 5] }
          ])
        }
        content.push({
          table: {
            widths: [120, 120, 120, 120],
            body: carouselItems
          },
          layout: 'lightHorizontalLines'
        })
      }
    }
  }
  return document
}

export const contentConfig = () => {
  return {
    footer: function(currentPage, pageCount) {
      return {
        margin: 10,
        columns: [
          {
            fontSize: 9,
            text: [
              {
                text: '--------------------------------------------------------------------------' +
                '\n',
                margin: [0, 20]
              },
              {
                text: currentPage.toString() + ' of ' + pageCount
              }
            ],
            alignment: 'center'
          }
        ]
      };
      // return currentPage.toString() + ' of ' + pageCount;
    },
    content: [
      {
        image: config.kobeLogoDataURL,
        width: 60,
        style: 'logo',
        alignment: 'left'
      }
    ],
    styles: {
      sectionTitle: {
        alignment: 'center',
        bold: true,
        fontSize: 20,
        marginTop: 0,
        // marginLeft: 9,
        marginBottom: 0,
        padding: 5
      },
      singleTitle: {
        fontSize: 13,
        marginBottom: 15,
        bold: true
      },
      image: {
        marginBottom: 15
      },
      header: {
        fontSize: 15,
        bold: true,
        marginBottom: 10,
        alignment: 'center'
      },
      middleHeader: {
        fontSize: 13,
        bold: true,
        marginTop: 5,
        marginBottom: 3
      },
      subheader: {
        fontSize: 12,
        marginBottom: 10
      },
      lastparagraph: {
        fontSize: 12,
        marginBottom: 15
      },
      footer: {
        alignment: 'center'
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: 'black'
      },
      tableTxt: {
        fontSize: 11
      },
      'html-h4': {
        fontSize: 11
      },
      tableTxtHighlight: {
        color: 'yellow'
      }
    },
    defaultStyle: {
      font: 'Arial'
    }
  }
}

export const getTextBlocks = (text) => {
  if (text !== undefined && text !== null) {
    let textP = text.replace(/\n/g, `<p>`);
    // textP = textP.split('<p>').map(t => t.trim());
    textP = textP.split(/(<span[^>]*>.*?<\/span>|<p>|<\/p>|<[^>]+>)/).filter(Boolean);
    return textP
  }
  return []
}

export const formatTextBlocks = (text) => {
  let fmtTxts = ContentPDFGeneratorInc.getTextBlocks(text)
  let fmtTextRun = fmtTxts.map(part => {
    if (part.startsWith("<span")) {
      // Create a TextRun for the span with background color
      // return new TextRun({
      //   text: part.replace(/<.*?>/g, ''), // Remove HTML tags
      //   color: "FFFF00", // Background color (yellow)
      //   bold: false, // Adjust styling as needed
      //   font: "Calibri", // Same global font
      // });
      return {
        text: htmlToPdfmake(part.replace(/<.*?>/g, '')),
        margin: [0, 5],
        fontSize: 9,
        style: 'tableTxtHighlight',
      }
    } else if (part.startsWith("<p>")) {
      // Start a new paragraph if <p> tag is found
      // This is handled by creating a new Paragraph in the loop
      return ''
    } else if (part.startsWith("</p>")) {
      // End the current paragraph
      return ''
    } else {
      // Create a TextRun for normal text
      return {
        text: htmlToPdfmake(part),
        margin: [0, 5],
        fontSize: 9
      }
    }
  })
  fmtTextRun = fmtTextRun.filter(s => s !== '')
  return fmtTextRun
}
export default {
  generatePDF,
  contentConfig,
  getTextBlocks,
  formatTextBlocks
}



// WEBPACK FOOTER //
// ./src/components/views/Pairing/CreatorConcept/ContentPDFGenerator.js